
/**
 * Custom component for text-only menu items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.1.1
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-03-24 (1.0.0) (jhoward)
 *      - <menu-item-text-only> will only display the menu item's description.
 *
 *    2023-04-24 (1.0.1) (jhoward)
 *      - <menu-item-text-only> will display the menu item's title if the description is blank.
 *
 *    2025-02-10 (1.1.0) (jhoward)
 *      - Add <menu-schedules> to the <menu-item-text-only> component if in admin view.
 *      - Add scheduling support to the <menu-item-text-only> component.
 *
 *    2025-04-08 (1.1.1) (jhoward)
 *      - Remove "visual_" prefix from class names in <MenuItemTextOnly>.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import {computedIsScheduled} from "../../../helpers/menu-sections";
import MenuSchedules from "../schedule/MenuSchedules.vue";

export default defineComponent({
  name: 'MenuItemTextOnly',
  components: {MenuSchedules},
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
  },
  computed: {
    isScheduled: computedIsScheduled,
  }
})
